import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AlertService } from '../alerts/alert.service';
import { AuthDispatchers } from '@store';
import { environment } from '../../../environments/environment';

@Injectable({providedIn: 'root'})
export class ErrorInterceptor implements HttpInterceptor {

    constructor(
        private alert: AlertService,
        private authDispatch: AuthDispatchers
    ) {}

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const suppressAlerts = req.headers.has('X-Suppress-Error-Alert');

        return next.handle(req).pipe(
            catchError((errorResponse: HttpErrorResponse) => {
                if (!suppressAlerts && errorResponse.url.indexOf('/auth/') === -1) {
                    if (errorResponse.status === 401) {
                        if (environment['authMode'] !== 'cloud') {
                            this.authDispatch.autoLogin();
                        }
                    } else if (errorResponse.status === 409) {
                        this.alert.createAlert(
                            `Advarsel i kald til
                            ${req.url}<br>
                            Bør blive håndteret af systemet`,
                            'warning'
                        );
                    } else {
                        this.alert.createAlert(
                            `Fejl i kald til
                            ${req.url}
                            Fejlkode: ${errorResponse.status}`,
                            'danger'
                        );
                        if (errorResponse.error) {
                            const alertMessage = errorResponse.error.title ?? errorResponse.error;
                            this.alert.createAlert(alertMessage, 'danger');
                        }
                    }
                }
                return throwError(errorResponse);
            })
        );

    }

}
